<div class="message-dialog">
  <div class="dialog-title" mat-dialog-title>
    {{ data.title | translate }}
  </div>
  <div class="dialog-content" mat-dialog-content>
    @if (data.htmlMessage) {
      <div class="message" [innerHTML]="data.htmlMessage | translate">
      </div>
    } @else () {
      <div class="message">
        {{ data.plainTextMessage | translate }}
      </div>
    }
    @if (data.logos && data.logos.length > 0) {
      <div class="logos">
        @for (logo of data.logos; track logo) {
          <img class="logo" [src]="logo.src" alt="logo" (click)="openInNewTab(logo.url)" />
        }
      </div>
    }
  </div>
  <div align="end" mat-dialog-actions>
    <button (click)="ok()" mat-flat-button>{{ 'general.ok' | translate }}</button>
  </div>
</div>
